import { all, call, put, takeEvery, takeLatest } from 'redux-saga/effects'
import { create, loadAll, remove, update, search, verify } from 'api/locations'
import actions from './actions'

export function* LOAD_ALL() {
  yield put({
    type: actions.SET_STATE,
    payload: {
      loading: true,
    },
  })
  const { response } = yield call(loadAll)
  yield put({
    type: actions.SET_STATE,
    payload: {
      loading: false,
    },
  })
  if (response) {
    const { locations, multi_location_url } = response.data
    yield put({
      type: actions.SET_STATE,
      payload: {
        data: locations,
        multiLocationURL: multi_location_url,
      },
    })
  }
}

export function* CREATE({ payload }) {
  yield put({
    type: actions.SET_STATE,
    payload: {
      creating: true,
    },
  })
  const { response, error } = yield call(create, payload)
  yield put({
    type: actions.SET_STATE,
    payload: {
      creating: false,
    },
  })
  if (response) {
    yield put({
      type: actions.HIDE_CREATE,
    })
    yield call(LOAD_ALL)
  } else {
    const { errors } = error.response?.data
    yield put({
      type: actions.SET_ERROR_STATE,
      payload: {
        create: errors,
      },
    })
  }
}

export function* UPDATE({ payload }) {
  yield put({
    type: actions.SET_STATE,
    payload: {
      updating: true,
    },
  })
  const { _id, updatedData } = payload
  const { response, error } = yield call(update, _id, updatedData)
  yield put({
    type: actions.SET_STATE,
    payload: {
      updating: false,
    },
  })
  if (response) {
    yield put({
      type: actions.HIDE_UPDATE,
    })
    yield call(LOAD_ALL)
  } else {
    const { errors } = error.response?.data
    yield put({
      type: actions.SET_ERROR_STATE,
      payload: {
        update: errors,
      },
    })
  }
}

export function* REMOVE({ payload }) {
  yield put({
    type: actions.SET_STATE,
    payload: {
      removing: true,
    },
  })
  const { _id } = payload
  const { response } = yield call(remove, _id)
  yield put({
    type: actions.SET_STATE,
    payload: {
      removing: false,
    },
  })
  if (response) {
    yield put({
      type: actions.HIDE_DELETE,
    })
    yield put({
      type: actions.REMOVE_DATA,
      payload: {
        _id,
      },
    })
  }
}

export function* SEARCH_DATA({ payload }) {
  const { email } = payload
  const { response } = yield call(search, email)
  if (response) {
    const { business } = response.data
    yield put({
      type: actions.SHOW_SEARCH,
      payload: {
        business,
      },
    })
  }
}

export function* EMAIL_VERIFY({ payload }) {
  const { code } = payload
  yield call(verify, code)
}

export default function* rootSaga() {
  yield all([
    takeLatest(actions.LOAD_ALL, LOAD_ALL),
    takeEvery(actions.CREATE, CREATE),
    takeEvery(actions.UPDATE, UPDATE),
    takeEvery(actions.REMOVE, REMOVE),
    takeLatest(actions.SEARCH_DATA, SEARCH_DATA),
    takeLatest(actions.EMAIL_VERIFY, EMAIL_VERIFY),
  ])
}
